const cookie = {
    // 写cookies
    setCookie(name, value) {
        let days = 1
        let exp = new Date()
        exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000)
        document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
    },
    // 读取cookies
    readCookie(name) {
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        if (document.cookie && arr) {
            return unescape(arr[2])
        }
        return null
    },
    // 删除cookies
    delCookie(name) {
        let cval = this.readCookie(name)
        if (cval != null) {
            document.cookie = name + '=' + cval + ';expires=' + (new Date(0)).toGMTString()
        }
    },
}

export default cookie
